export enum GLOBAL_ERROR {
  MISSING_PERMISSIONS = 'MISSING_PERMISSIONS',
  NOT_FOUND = 'NOT_FOUND',
  AUTH_FAILURE = 'AUTH_FAILURE',
  NO_CONNECTION = 'NO_CONNECTION',
}
